import { RootState } from '../store';
import { TLocalCartItem } from './localCart.types';

export const selectCartItems = (state: RootState): TLocalCartItem[] =>
  state.localCart.items;

export const selectCartItemCount = (state: RootState): number =>
  state.localCart.items.reduce((total, item) => total + item.quantity, 0);

export const selectCartTotal = (state: RootState): number =>
  state.localCart.items.reduce(
    (total, item) => total + item.pricePerItem * item.quantity,
    0
  );

export const selectCartItemById =
  (id: string) =>
  (state: RootState): TLocalCartItem | undefined =>
    state.localCart.items.find((item) => item.id === id);

export const selectCartItemsCount = (state: RootState): number =>
  state.localCart.items.length;
